import styled from 'styled-components';
import { CircleCheckMark, Exclamation, QuestionCircle, Warning } from '../Icons';
import { TypeStyle } from '../TypeStyle';
import { ALERT_INTENT } from '.';
function getFillForIntent(theme, intent) {
    switch (intent) {
        case ALERT_INTENT.Success:
            return theme.color.fill.celebratory.subtle;
        case ALERT_INTENT.Error:
            return theme.color.fill.critical.subtle;
        case ALERT_INTENT.Warn:
            return theme.color.fill.caution.subtle;
        default:
            return theme.color.fill.info.subtle;
    }
}
function getStrokeForIntent(theme, intent) {
    switch (intent) {
        case ALERT_INTENT.Success:
            return theme.color.stroke.celebratory.text.on.subtle;
        case ALERT_INTENT.Error:
            return theme.color.stroke.critical.text.on.subtle;
        case ALERT_INTENT.Warn:
            return theme.color.stroke.caution.text.on.subtle;
        default:
            return theme.color.stroke.info.text.on.subtle;
    }
}
export const AlertWrapper = styled.aside `
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  background-color: ${o => getFillForIntent(o.theme, o.$intent)};
  border-left-width: 4px;
  border-left-style: solid;
  border-left-color: ${o => getStrokeForIntent(o.theme, o.$intent)};
  padding: ${o => o.theme.spacing(4)};
  max-width: 500px;
`;
export const AlertContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(1)};
`;
export const AlertIcon = styled.div.attrs({ role: 'presentation' }) `
  color: ${o => o.$intent && getStrokeForIntent(o.theme, o.$intent)};
`;
export const AlertTitle = styled(TypeStyle.HeadlineMicro).attrs({ asTag: 'span' }) `
  color: ${o => o.theme.color.text.primary.on.subtle};
  font-weight: 700;
`;
export const AlertMessage = styled(TypeStyle.BodyMicro).attrs({ asTag: 'p' }) `
  color: ${o => o.theme.color.text.primary.on.subtle};
  font-weight: 500;
`;
const sharedIconAttrs = {
    width: '16px',
    height: '16px',
};
export const SuccessIcon = styled(CircleCheckMark).attrs({
    fill: 'currentColor',
    ...sharedIconAttrs,
}) ``;
export const WarnIcon = styled(Warning).attrs(sharedIconAttrs) `
  /*
   * This icon component defines the triangle border as a 'path', which causes it to be filled with the current color.
   * We need to make sure the first path only inherits stroke instead of fill
   */
  path {
    fill: currentColor;
    &:first-child {
      fill: none;
      stroke: currentColor;
    }
  }
`;
export const InfoIcon = styled(QuestionCircle).attrs({ fill: 'currentColor', ...sharedIconAttrs }) ``;
export const ErrorIcon = styled(Exclamation).attrs({ fill: 'currentColor', ...sharedIconAttrs }) ``;
//# sourceMappingURL=styles.js.map